import React, { useState, useEffect } from 'react';
import { AppRouter } from "./routes/AppRoutes";

import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import Grid from "@mui/material/Grid";
import Paper from '@mui/material/Paper';
import Card from "@mui/material/Card";

import GoogleIcon from '@mui/icons-material/Google';

// import { createStyles, makeStyles } from "@mui/styles";

const defaultTheme = createTheme(
  {
    typography: {
      allVariants: {
        fontFamily: ['Albert Sans', 'sans-serif'].join(','),
        textTransform: 'none',
        fontWeight: 300,
      },
    },
  }
);

function App() {
  const [user, setUser] = useState<any>([]);
  const [profile, setProfile] = useState<any>({});

  const login = useGoogleLogin({
    onSuccess: (codeResponse: any) => setUser(codeResponse),
    onError: (error) => console.log('Login Failed:', error)
  });

  useEffect(
    () => {
      const loggedInUser = localStorage.getItem("user");
      // console.log('PROFILE: ', profile);
      if (loggedInUser) {
        const foundUser = JSON.parse(loggedInUser);
        setProfile(foundUser);
      }
      else {
        axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: 'application/json'
            }
          })
          .then((res) => {
            setProfile(res.data);
            localStorage.setItem('user', JSON.stringify(res?.data));
            window.location.reload();
          })
          .catch((err) => console.log(err));
      }
    },
    [user]
  );

  const paperStyle={padding:"90px !important", width: 400, textAlign: "center"}

  return (
    <div className="App">
      <ThemeProvider theme={defaultTheme}>
          {profile && Object.keys(profile).length !== 0 ? (
            <AppRouter />
          ) : (
            <Grid
              container
              sx={{
                background: "linear-gradient(96deg, #01275A 50%, #01AEF0 calc(50% + 1px))",
                minWidth: "100%",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
              }}
              spacing={0}
              alignItems="center"
              justifyContent="center">
              <Paper elevation={10} sx={paperStyle}>
                <Grid mb={2} item>
                  <Box sx={{backgroundColor: "#fff", padding: "10px"}}>
                    <img src="/global/images/sk-logo-trans.png" alt="" style={{ width: '80%'}} />
                  </Box>
                </Grid>
                <Grid mb={2} item>
                  <Typography variant="h5">Welcome To ShellKode ShiftRoster</Typography>
                </Grid>
                <Grid item>
                  <Typography mb={1}>Log into your account</Typography>
                </Grid>
                <Button 
                    sx={{
                    backgroundColor: "#3F80EC",
                    margin:'8px 0 !important',
                    padding: "8px !important",
                    fontSize: "18px !important",
                    fontWeight: "400 !important",
                    '&:hover': {
                      background: "#3F80EC",
                    },
                  }} variant="contained" fullWidth startIcon={<GoogleIcon />} onClick={() => login()}>Google</Button>
              </Paper>
        </Grid>
        )}
      </ThemeProvider>
    </div>
  );
}

function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default App;
